<div
  *ngIf="person && current_user_id && person.id !== current_user_id.id"
  class="d-flex justify-content-center bg-primary"
>
  <span class="text-white text-center fw-medium py-2">
    {{ 'ordering_for' | translate }}

    <a href="javascript:void(0)" (click)="openProfile()" class="text-white">
      {{ person.person_name }} ({{ person.email }})
    </a>
  </span>
</div>
